/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ContactDefs from './defs.defs.js'

const $nsid = 'app.bsky.contact.importContacts'

export { $nsid }

/** Import contacts for securely matching with other users. This follows the protocol explained in https://docs.bsky.app/blog/contact-import-rfc. Requires authentication. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    token: l.string(),
    contacts: l.array(l.string(), { minLength: 1, maxLength: 1000 }),
  }),
  l.jsonPayload({
    matchesAndContactIndexes: l.array(
      l.ref<ContactDefs.MatchAndContactIndex>(
        (() => ContactDefs.matchAndContactIndex) as any,
      ),
    ),
  }),
  [
    'InvalidDid',
    'InvalidContacts',
    'TooManyContacts',
    'InvalidToken',
    'InternalError',
  ],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
